import Vue from 'vue'
import Store from 'store'

import PromotionCollections from './PromotionCollections.vue'

const el = '.nti-component--promotion'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        new Vue({
            store: Store,
            el,
            components:{
                PromotionCollections
            },
            template: '<PromotionCollections />'
        })
    }
}

export default {
    render
}